import { useLogError } from '../components/ErrorBoundary/useLogError';
import { useEffect, useState } from 'react';
import { requestNotificationPermission } from '../utils/notifications';

export const useNotificationPermission = (enabled: boolean = true) => {
	const [permission, setPermission] = useState<
		NotificationPermission | PermissionState
	>();

	const logError = useLogError('useNotificationPermission');
	useEffect(() => {
		if (enabled) {
			requestNotificationPermission()
				.then(setPermission)
				.catch((error) => logError('requestNotificationPermission', { error }));
			if (navigator && 'permissions' in navigator) {
				navigator.permissions
					.query({ name: 'notifications' })
					.then((status) => {
						status.onchange = function () {
							setPermission(this.state);
						};
					});
			} else {
				logError('Permission', {
					error: new Error(
						'Navigator.permissions not supported. Impossible to detect notification permission changes'
					),
				});
			}
			// navigator.permissions.query({ name: 'push' }).then(function (status) {
			// 	status.onchange = function () {
			// 		console.log('push', this.state);
			// 	};
			// });
		} else {
			setPermission(undefined);
		}
	}, [logError, enabled]);

	return permission;
};
